interface ContentBlockData {
    contentBlockId: string
    surveyId: string
    merchantId: string
    storeId: string
    questionId: string
    orderIndex: number
    blocks: Array<{
        blockId: string
        content: {
            heading?: string
            headingLevel?: number
            text?: string
            altText?: string
            caption?: string
            imageId?: string
            imageUrl?: string
            // Coupon code fields
            code?: string
            description?: string
            expiryDate?: string
            termsLink?: string
        }
        blockType: 'heading' | 'text' | 'image' | 'coupon-code'
        orderIndex: number
    }>
    layout: string
    isVisible: boolean
    status: string
    deletedAt: string | null
    createdAt: string
    updatedAt: string
}

interface ContentBlockProps {
    contentBlocks?: ContentBlockData
    questionId: string
}

const ContentBlock = ({ contentBlocks, questionId }: ContentBlockProps) => {
    if (!contentBlocks?.blocks || contentBlocks.blocks.length === 0) {
        return null
    }

    // Sort blocks by orderIndex
    const sortedBlocks = [...contentBlocks.blocks].sort(
        (a, b) => a.orderIndex - b.orderIndex
    )

    const renderCouponCard = (block: any) => {
        const content = block.content || {}
        if (!content.code) return null

        return (
            <div key={block.blockId} className="mt-6 w-full">
                <div className="w-fit rounded-lg bg-[#005BD3] px-4 py-2 flex items-center justify-center">
                    <div className="text-[13px] font-bold text-white tracking-wider uppercase">
                        {content.code}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="" key={`${questionId}-preview-modal`}>
            {sortedBlocks.map((block) => {
                switch (block.blockType) {
                    case 'heading':
                        return (
                            <div key={block.blockId}>
                                {block.content.heading &&
                                    block.content.heading.trim() !== '' && (
                                        <h3 className="text-[16px] font-semibold text-[#303030]">
                                            {block.content.heading}
                                        </h3>
                                    )}
                            </div>
                        )
                    case 'text':
                        return (
                            <div key={block.blockId} className="mt-2">
                                {block.content.text &&
                                    block.content.text.trim() !== '' && (
                                        <p className="text-[13px] text-[#616161]">
                                            {block.content.text}
                                        </p>
                                    )}
                            </div>
                        )
                    case 'image':
                        return (
                            <div key={block.blockId} className="mt-6">
                                {block.content.imageUrl &&
                                    block.content.imageUrl.trim() !== '' && (
                                        <div className="flex justify-start">
                                            <img
                                                src={block.content.imageUrl}
                                                alt={
                                                    block.content.altText ||
                                                    'Content image'
                                                }
                                                className="max-w-full h-auto rounded-md shadow-sm"
                                                style={{ maxHeight: '442px' }}
                                            />
                                        </div>
                                    )}
                            </div>
                        )
                    case 'coupon-code':
                        return renderCouponCard(block)
                    default:
                        return null
                }
            })}
        </div>
    )
}

export default ContentBlock
